import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Store, BookOpen, CreditCard, Users } from "lucide-react";
import { Link } from "react-router-dom";

const Stat = ({ icon: Icon, n, l, to }) => (
  <Link to={to} className="zq-card p-5 flex items-center gap-4 hover:-translate-y-0.5 transition">
    <div className="w-10 h-10 rounded-md bg-zq-orange-light text-zq-orange flex items-center justify-center"><Icon size={20}/></div>
    <div>
      <div className="text-2xl font-bold">{n}</div>
      <div className="text-sm text-zq-muted">{l}</div>
    </div>
  </Link>
);

export const AdminOverview = () => {
  const [stats, setStats] = useState({ restaurants: 0, blogs: 0, payments: 0 });

  useEffect(() => {
    Promise.all([
      api.get("/admin/restaurants"),
      api.get("/admin/blogs"),
      api.get("/admin/subscriptions"),
    ]).then(([r, b, s]) => {
      setStats({
        restaurants: r.data.length,
        blogs: b.data.length,
        payments: s.data.payments?.length || 0,
        active: r.data.filter((x) => !x.suspended).length,
      });
    }).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-overview">
      <h1 className="text-2xl font-bold">Overview</h1>
      <p className="text-sm text-zq-muted mt-1">High-level numbers across your platform.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
        <Stat icon={Store} n={stats.restaurants} l="Restaurants" to="/admin/restaurants"/>
        <Stat icon={Users} n={stats.active || 0} l="Active accounts" to="/admin/restaurants"/>
        <Stat icon={BookOpen} n={stats.blogs} l="Blog posts" to="/admin/blogs"/>
        <Stat icon={CreditCard} n={stats.payments} l="Payments recorded" to="/admin/subscriptions"/>
      </div>
    </div>
  );
};
